import { render, staticRenderFns } from "./dialogos.vue?vue&type=template&id=707f4c8a&scoped=true&"
import script from "./dialogos.vue?vue&type=script&lang=js&"
export * from "./dialogos.vue?vue&type=script&lang=js&"
import style0 from "./dialogos.vue?vue&type=style&index=0&id=707f4c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707f4c8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
